import SubHeader from '../helpers/SubHeader';
import ImagesItem from './ImagesItem';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { NDialog, NLoading } from 'nayan';
import { formatQueryData } from '../../config/Config';
import ImagesNew from './ImagesNew';
import { useCategoryData, useImagesData } from '../../services/ImagesService';

const Images = () => {
  const params: any = useParams();
  const [showModal, setShowModal] = useState(false);
  const { isLoading, data } = useImagesData(params.category);
  const images = formatQueryData(data) || [];
  const { isLoading: isCategoryLoading, data: categoryData } = useCategoryData(params.category);
  const category = formatQueryData(categoryData) || {};

  return (
    <div className="p-3">
      <SubHeader title="Images" showButton={true} clickButton={() => setShowModal(true)} />
      <NDialog title="Add Image" isOpen={showModal} onClose={() => setShowModal(false)}>
        <ImagesNew category={category} closeModal={() => setShowModal(false)} />
      </NDialog>
      {(isLoading || isCategoryLoading) && <NLoading />}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-3 pt-3 mb-3">
        {!isLoading && !isCategoryLoading && images.map((image: any) => <ImagesItem category={category} image={image} key={image.uuid} />)}
      </div>
      {!isLoading && !isCategoryLoading && !images.length && <div className="p-3 text-center">No images available!</div>}
    </div>
  );
};

export default Images;
